import React from "react";
import { Text, Device } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";

function parseDeviceName(deviceName) {
  return deviceName.replace("PlayStation4", config.get().sdk.deviceName);
}

function parseFamilyType(familyType) {
  let parsed = familyType !== "androidtv" && familyType !== "appleTV" && familyType.includes("tv") ? "tv" : familyType;
  return parsed;
}

export const Devices = ({ devices }) => {
  return (
    <>
      {devices && (!devices.length || devices.length === 0) ? (
        <Text text={i18n.get("pages.settings.devices.notRegistered")} type="secondary" />
      ) : (
        devices &&
        devices.map(device => (
          <Device
            key={`key_${device.name}`}
            deviceName={{ [`${i18n.get("pages.settings.devices.name")}`]: parseDeviceName(device.name) }}
            deviceKey={{ [`${i18n.get("pages.settings.devices.key")}`]: device.id }}
            icon={parseFamilyType(device.familyType)}
          />
        ))
      )}
      <Text text={i18n.get("pages.settings.devices.registered")} type="secondary" />
    </>
  );
};
